/*
	Typepost 3.5, a simple text post generator for social media.
	By Chuck Aligbe [http://chuck.aligbe.com]

*/
import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {}
});

export default app;
